import { Grid, useTheme } from '@mui/material';
import { flightIncludes } from '@shared/helpers/flights/reserve';
import RenderBaggageIcons from '@FlightsComponents/RenderBaggageIcons';
import { getBaggageInfoStyles } from './styles';
import ItineraryText from '@FlightsComponents/ItineraryText';

const BaggageInfo = ({ baggage, baggageIsRow = false }) => {
  const theme = useTheme();
  const styles = getBaggageInfoStyles(baggageIsRow);

  return (
    <Grid container sx={styles.container} id="grid-baggage-info-container">
      {styles.showTitle && (
        <Grid item xs={12}>
          <ItineraryText
            sx={{
              color: theme.tertiary,
              fontWeight: 600,
              textAlign: 'center',
              pb: '4px',
            }}
          >
            Equipaje
          </ItineraryText>
        </Grid>
      )}

      <Grid item xs={12} sx={styles.innerGrid}>
        <Grid item sx={styles.iconWrapper}>
          <RenderBaggageIcons
            baggage={baggage}
            transform={styles.iconTransform}
          />
        </Grid>

        <ItineraryText sx={styles.text}>
          {flightIncludes(
            baggage?.backpack_baggage,
            baggage?.hand_baggage,
            baggage?.baggage_hold
          )}
        </ItineraryText>
      </Grid>
    </Grid>
  );
};

export default BaggageInfo;
